﻿import { WorkItemInfo } from 'runtime/data/workiteminfo';

export class AssignRequested {
    constructor(public workItemInfo: WorkItemInfo, public targetUserId: string, public completionAction: () => void) {}

    static eventName() { return 'WorkTray.AssignRequested'; }

    eventName = AssignRequested.eventName;
}